// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__FlKGg","productName":"Table_productName__2x-Zm"};